import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { FaTruck } from "react-icons/fa"
import { HappyButton } from "../../common/Buttons"
import useStore from "../../../store"
import useUserType from "../../../hooks/useUserType"
import { carpoolEnabled } from "../../../utilities/featureFlags"

export default function TransportUnitButton({ unit }) {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { isDealer } = useUserType()
  const dealer = useStore((state) => state.dealer)

  if (!isDealer || !carpoolEnabled(dealer)) {
    return null
  }

  const handleTransportUnit = () => {
    navigate(`/transportation/${unit.id}`, { state: { autoOpenQuote: true } })
  }

  return (
    <HappyButton
      text={<span className="flex items-center justify-center gap-2"><FaTruck /> {t('Get Transport Quote')}</span>}
      onClick={handleTransportUnit}
    />
  )
}
